// CategoryCard.jsx
import React from "react";
import clsx from "clsx";
import IconCategory from "./IconCategory.jsx";

function CategoryCard({ label, selected, onClick }) {
    return (
        <button
            onClick={onClick}
            className={clsx(
                "whitespace-nowrap px-4 py-2 rounded-full text-[13px] font-semibold transition-all duration-200 active:scale-95",
                selected
                    ? "text-white shadow-sm"
                    : "bg-white border border-gray-200 text-gray-600 hover:border-primary/40 hover:text-primary"
            )}
            style={selected ? {
                background: 'linear-gradient(135deg, #3e7dae 0%, #2d6a9a 100%)',
            } : undefined}
        >
            {label}
        </button>
    );
}

export default CategoryCard;